import { useMemo } from 'react';

import { Pane, PaneHeader, PaneTitle, PaneBody } from '../components/pane';
import { UnderConstruction } from './UnderConstruction';

const TeamAssignmentsTable = () => {
  return (
    <UnderConstruction>
      We&apos;re cooking up an at-a-glance distribution of your team&apos;s
      quoting workload.
    </UnderConstruction>
  );
};

export type TeamAssignmentsPaneProps = {
  activeGroupIds: number[];
};

export const TeamAssignmentsPane = ({
  activeGroupIds,
}: TeamAssignmentsPaneProps) => {
  const websocketOptions = useMemo(() => {
    return {
      topic: activeGroupIds.map((id) => `${id}.orders.created`),
    };
  }, [activeGroupIds]);

  return (
    <Pane refetchQueryKey="" websocketOptions={websocketOptions}>
      <PaneHeader>
        <PaneTitle>Team Assignments</PaneTitle>
        {/* <PaneSubtitle>Created in the last 90 days</PaneSubtitle> */}
      </PaneHeader>
      <PaneBody>
        <TeamAssignmentsTable />
      </PaneBody>
    </Pane>
  );
};
